import React from 'react';

function RequiredMark() {
  return <span style={{ color: 'var(--danger-color)' }}>*</span>;
}

export default RequiredMark;
